export const default_offer = {
  perkName: "",
  perkLogo: "",
  startTime: null,
  endTime: null,
};



// WEBPACK FOOTER //
// ./src/screens/Perks/constants/default.js